<template>
  <router-view></router-view>
</template>

<script>
import { mapActions } from 'vuex'


export default {
  name: 'App',
  components: {
  },
  created() {
  },
  mounted() {
    this.setIsMobile(this._isMobile())
  },
  methods: {
    ...mapActions([
        'setIsMobile'
    ]),
    _isMobile() {
      let isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return isMobile !== null
    },
    onResize() {
      this.setIsMobile(this._isMobile())
    }
  }
}
</script>

<style>
html, body, div {
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow: hidden;
}
#app::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
</style>
